import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.apply.home');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-apply-home',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.apply.home/view.scss */
:host {
  display: block;
}`],
})
export class PageApplyHomeComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public items: any[] = [];
    public loaded: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call('list');
        if (code === 200) {
            this.items = data.rows || [];
        }
        this.loaded = true;
        await this.service.render();
    }

    public open(slug: string) {
        this.service.href(`/apply/f/${slug}`);
    }

    public dday(it: any): string {
        if (!it.apply_end) return '';
        const end = new Date(String(it.apply_end).replace(' ', 'T'));
        const today = new Date(); today.setHours(0,0,0,0);
        const diff = Math.ceil((end.getTime() - today.getTime()) / (1000*60*60*24));
        if (diff > 0) return `D-${diff}`;
        if (diff === 0) return 'D-Day';
        return '마감';
    }
}

export default PageApplyHomeComponent;